import React from 'react';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemSection } from './components/ProblemSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { Curriculum } from './components/Curriculum';
import { ContentPreview } from './components/ContentPreview';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { BackedBy } from './components/BackedBy';
import { Guarantee } from './components/Guarantee';
import { Format } from './components/Format';
import { FAQ } from './components/FAQ';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalOffer } from './components/FinalOffer';
import { FinalCTA } from './components/FinalCTA';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 pb-20 font-sans text-white lg:pb-0" data-id="element-0" data-mp="3recedkz46pg7">
      <PromoBar data-id="element-1" data-mp="56ntiw8hdol" />
      <main data-id="element-2" data-mp="7su7f7e1n58">
        <Hero data-id="element-3" data-mp="2zl3brl12165b" />
        <StatsBar data-id="element-4" data-mp="2zlle8zeb8glo" />
        <ProblemSection data-id="element-5" data-mp="2zm4zaoz9bl3x" />
        <WhoIsItFor data-id="element-6" data-mp="2zmwif0bo3qdb" />
        <ContentPreview data-id="element-7" data-mp="2zng0ch1bierc" />
        <Curriculum data-id="element-8" data-mp="33m5be2yvvk7t" />
        <Bonuses data-id="element-9" data-mp="33nq6put0v76q" />
        <OfferStack data-id="element-10" data-mp="33n6yj5t6bx5w" />
        <Testimonials data-id="element-11" data-mp="33orki71fa7s5" />
        <AboutAuthor data-id="element-12" data-mp="38m1fs3bhtdnw" />
        <BackedBy data-id="element-13" data-mp="38li7lebna3n2" />
        <Guarantee data-id="element-14" data-mp="38l06o4e1f18t" />
        <Format data-id="element-15" data-mp="38kgocmkh6au9" />
        <FAQ data-id="element-16" data-mp="38o4f5dyjcj5a" />
        <BeforeAfter data-id="element-17" data-mp="3dkl4ucldv5kh" />
        <FinalOffer data-id="element-18" data-mp="3dl4ktnrh3jvv" />
        <FinalCTA data-id="element-19" data-mp="3dmfq5s0kgzp3" />
        <Contact data-id="element-20" data-mp="3diruonbka37q" />
      </main>
      <Footer data-id="element-21" data-mp="nvsup6ui4rx0" />
      <StickyBuyBar data-id="element-22" data-mp="nwc2huqftzxb" />
      <WhatsAppFloat data-id="element-23" data-mp="nur6e0oh68xc" />
      <PurchaseNotifications data-id="element-24" data-mp="nvasltl5rjh6" />
    </div>;
}